import { RESOURCE_TYPE_ICONS } from 'v1/helpers/iconSets';
import { cn } from 'v5/platform/dom/cn';

export function getResourceTypeIconSrc(icon?: string): string {
  const iconKey = icon && icon in RESOURCE_TYPE_ICONS ? icon : 'default';
  return `/images/${RESOURCE_TYPE_ICONS[iconKey].black}`;
}

type ResourceTypeIconProps = {
  icon?: string;
  alt?: string;
  className?: string;
};

export function ResourceTypeIcon({
  icon,
  alt = '',
  className
}: ResourceTypeIconProps) {
  return (
    <img
      src={getResourceTypeIconSrc(icon)}
      alt={alt}
      className={cn('size-5 shrink-0', className)}
    />
  );
}
